// extracted by mini-css-extract-plugin
export default {"error_boundary":"ErrorBoundary_error_boundary__vIL6g","code_wrapper":"ErrorBoundary_code_wrapper__kutIi","shimmer":"ErrorBoundary_shimmer__p+J3q"};